import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Divider,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';
import ConfirmButton from '../atoms/ConfirmButton';
import BackButton from '../atoms/BackButton';
import RegisterButton from '../atoms/RegisterButton';

const styles = {
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  contentContainer: {
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5
  },
  description: {
    display: 'block',
    fontSize: 18,
    marginBottom: 20
  },
  fs14: {
    fontSize: 14
  },
  radioGroup: {
    marginBottom: 10
  },
  buttonContainer: {
    marginTop: 15
  },
  paper: {
    padding: 20,
    marginTop: 15
  },
  detailTable: {
    width: '100%',
    padding: 15
  },
  tableCellItem: {
    backgroundColor: '#D9D9D9',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 240,
    border: 'none'
  },
  tableCellData: {
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line',
    border: 'none'
  }
};

const enhance = compose(
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('newStatus', 'setNewStatus', 'AVAILABLE'),
  withState('isConfirm', 'setIsConfirm', false)
);

const button = enhance(
  ({
    classes,
    open,
    onClose,
    newStatus,
    setNewStatus,
    isConfirm,
    setIsConfirm,
    updateShopStatus
  }) => {
    useEffect(() => {
      if (open) {
        setIsConfirm(false);
        setNewStatus('AVAILABLE');
      }
    }, [open]);

    return (
      <Modal open={open} onClose={onClose} className={classes.modal}>
        {!isConfirm ? (
          <div className={classes.contentContainer}>
            <Typography className={classes.title} variant="h6">
              一括開店状況変更
            </Typography>
            <FormLabel className={classes.fs14}>一括開店状況*</FormLabel>
            <RadioGroup
              row
              value={newStatus}
              onChange={e => {
                setNewStatus(e.target.value);
              }}
              className={classes.radioGroup}
            >
              <FormControlLabel
                value="AVAILABLE"
                control={<Radio color="primary" />}
                label="利用可能に変更"
              />
              <FormControlLabel
                value="PRE_AVAILABLE"
                control={<Radio color="primary" />}
                label="準備中に変更"
              />
            </RadioGroup>
            <Divider />
            <div className={classes.buttonContainer}>
              <CancelButton onClickAction={onClose} color="primary" />
              <ConfirmButton
                onClickAction={() => {
                  setIsConfirm(true);
                }}
              />
            </div>
          </div>
        ) : (
          <div className={classes.contentContainer}>
            グループに所属している店舗の開店状況を
            {newStatus === 'AVAILABLE' ? '利用可能に変更' : '準備中に変更'}
            しましょうか？
            <div className={classes.buttonContainer}>
              <BackButton
                onClickAction={() => {
                  setIsConfirm(false);
                }}
              />
              <RegisterButton
                onClickAction={() => updateShopStatus(newStatus)}
              />
            </div>
          </div>
        )}
      </Modal>
    );
  }
);

export default withStyles(styles)(button);
